export const AccountDisconnectsQueryType = {
  STARTED: "started",
  TEN_DAY: "ten_day",
  FOURTEEN_DAY: "fourteen_day",
  FINAL_READY: "final_ready",
  SENDING_FINAL: "batch_pending_final",
  DISCONNECT_POST_READY: "disconnect_post_ready",
  SENDING_DISCONNECT: "batch_pending_disconnect",
  DISCONNECT_POSTED: "disconnect_post",
  COMPLETED: "completed",
  ALL: "all",
};
